




















































import { Component, Prop, Mixins } from "vue-property-decorator";
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import { DataModules } from "@/store/modules/data";
import { UUID } from "@/data/enums";
import { IBrand } from "@/models/brands";

@Component({
  components: {
    "payment-method-list-row": () =>
      import("@/components/app/global/payments/paymentMethodListRow.vue")
  }
})
export default class BrandPaymentMethodsList extends Mixins(
  FilteringSortingTableStore
) {
  //Props

  @Prop({ default: UUID.ORG })
  public brandId!: IBrand["id"];

  @Prop({ default: () => ({}) })
  public readonly manualFilters!: Record<string, string | number | boolean>;

  @Prop({ default: true })
  public showTableHead!: boolean;

  // Override prop defaults from mixin

  @Prop({ default: "PMT1" })
  public declare id: string;

  @Prop({ default: "$brand_payment_methods" })
  public declare dataScope: string;

  @Prop({ default: true })
  public declare ignoreHistory: boolean;

  @Prop({ default: 5 })
  public declare limit: number;

  // Data

  public dataModule: DataModules = DataModules.PAYMENT_DETAILS;

  // Life-cycle methods

  public created() {
    this.getData();
  }

  // Computed

  public get brandFilter() {
    return this.brandId !== UUID.ORG ? { brand_id: this.brandId } : {};
  }

  // Overrides mixin method

  public getStoreParams(payload: any): Promise<any> {
    return this.$_.merge(payload, {
      storeModule: this.dataModule,
      ignoreStored: true,
      params: {
        order: "-created_at",
        with: "gateway,client.image",
        ...this.brandFilter,
        ...this.manualFilters
      }
    });
  }
}
